export default "<app-calendar [selectedDate]=\"settings\"\r\n              (editedDate)=\"onEditedData($event)\">\r\n</app-calendar>\r\n"